import { cn } from '@yanolja-rnd/nol-design-system'

/**
 * 구매 불가 상태에 따른 클래스를 계산하는 헬퍼 함수
 * @param disabledSale - 구매 불가 여부
 * @param baseClasses - 기본 클래스명
 * @param additionalDisabledClasses - 구매 불가 시 추가할 클래스명
 * @returns 조합된 클래스명
 */
export const getDisabledClasses = (
  disabledSale: boolean,
  baseClasses: string,
  additionalDisabledClasses?: string
): string => {
  return cn(baseClasses, disabledSale && `${additionalDisabledClasses} text-text-neutral-medium`)
}
